import Hero from "../sections/Hero";
import Mission from "../sections/Mission";
import Products from "../sections/Products";
import About from "../sections/About";
import Media from "../sections/Media";
// import Blog from "../sections/Blog";

export default function Home() {
  return (
    <main>
      <Hero />
      <Mission />
      <Products />
      <About />
      <Media />
      {/* <Blog /> */}
    </main>
  );
}
